
///
/// Main navigation 
///
/// Toggle the TabIndex and Aria-Hidden attribute values of menu list items based on user actions
///

// todo :
// - moveHorizontally could do with refactoring
// moveHorizontally - would be nice if the 'right' parameter was a 'direction' enum; Left | Right

import { findAncestor, getNextSibling, getPreviousSibling } from './_functions';

//const directions = {
//	UP: 'up',
//	DOWN: 'down',
//	LEFT: 'left',
//	RIGHT: 'right'
//}

window.SetUpMainNav = function () {

	var navbar = document.getElementById("MainNavigation"); // HeaderContainer
	var menuItems = document.querySelectorAll('.main-navigation__list-item-link');
	var headerContainer = document.querySelector('.header-container');

	// toggle Aria and TabIndex attribute values on DOM elements relating to the link
	function toggleMainNavigation(link, show) {

		// find the top-level list item
		var topLevelListItem = findAncestor(link, 'main-navigation__list-item--level-1')

		if (topLevelListItem) {

			// find the nested dropdown container and toggle the aria-hidden
			var dropdownContainer = topLevelListItem.querySelectorAll('.main-navigation__dropdown');

			if (dropdownContainer) {
				if (show) {
					dropdownContainer[0].setAttribute('aria-hidden', 'false');
				} else {
					dropdownContainer[0].setAttribute('aria-hidden', 'true');
				}
			}

			// and find every link and toggle the tabindex
			var childLinks = dropdownContainer[0].querySelectorAll('.main-navigation__list-item-link');

			for (var l = 0; l < childLinks.length; l++) {

				var childLink = childLinks[l];

				if (show) {
					childLink.setAttribute('tabindex', '0');
				} else {
					childLink.setAttribute('tabindex', '-1');
				}
			}
		}

	}

	// move horizontally through either the top level navigaiton links or the child navigation group depending on where current focus is
	function moveHorizontally(link, right) {
 
		// is this a top level list item link
		if (link.classList.contains('main-navigation__list-item-link--level-1')) {

			// find the parent level-1 li
			var parentListItem = findAncestor(link, 'main-navigation__list-item--level-1');
			// find the parent ul
			var parentUnorderedList = findAncestor(parentListItem, 'main-navigation__list');
			// and all the list items in this unordered list
			var allListItems = parentUnorderedList.querySelectorAll('.main-navigation__list-item--level-1');

			if (allListItems.length > 1) {

				var sibling = null;

				if (right)
					sibling = getNextSibling(parentListItem, '.main-navigation__list-item--level-1');
				else
					sibling = getPreviousSibling(parentListItem, '.main-navigation__list-item--level-1');

				if (sibling) {

					// find all links in this list
					var linkItems = sibling.querySelectorAll('.main-navigation__list-item-link--level-1');

					if (linkItems) {
						// find the first link in this list
						var targetLink = linkItems[0];
						// and select it
						if (targetLink) {
							targetLink.focus();
						}
					}

				} else {
					// at the last group, move to the first item...
					// find the first list item group
					var listItem = null;

					if (right)
						listItem = allListItems[0];
					else
						listItem = allListItems[(allListItems.length - 1)];

					// find all links in this list
					var linkItems = listItem.querySelectorAll('.main-navigation__list-item-link--level-1');

					if (linkItems) {
						// find the first link in this list
						var targetLink = linkItems[0];
						// and select it
						if (targetLink) {
							targetLink.focus();
						}
					}

				}

			}

		} else {

			// find the parent level-2 li
			var parentListItem = findAncestor(link, 'main-navigation__list-item--level-2');
			// find the parent ul
			var parentUnorderedList = findAncestor(parentListItem, 'main-navigation__child-list--level-2');
			// and all the list items in this unordered list
			var allListItems = parentUnorderedList.querySelectorAll('.main-navigation__list-item--level-2');
			// are there more than 1 groups
			if (allListItems.length > 1) {
				if (parentListItem) {

					var sibling = null;

					if (right)
						sibling = getNextSibling(parentListItem, '.main-navigation__list-item--level-2');
					else
						sibling = getPreviousSibling(parentListItem, '.main-navigation__list-item--level-2');

					if (sibling) {

						// find all links in this list
						var linkItems = sibling.querySelectorAll('.main-navigation__list-item-link--level-2');

						if (linkItems) {
							// find the first link in this list
							var targetLink = linkItems[0];
							// and select it
							if (targetLink) {
								targetLink.focus();
							}
						}

					} else {
						// at the last group, move to the first item...
						// find the first list item group
						var listItem = null;

						if (right)
							listItem = allListItems[0];
						else
							listItem = allListItems[(allListItems.length - 1)];

						// find all links in this list
						var linkItems = listItem.querySelectorAll('.main-navigation__list-item-link--level-2');

						if (linkItems) {
							// find the first link in this list
							var targetLink = linkItems[0];
							// and select it
							if (targetLink) {
								targetLink.focus();
							}
						}

					}

				}
			}
		}
	}

	function moveVertically(link, down) {

		// is this a top level list item link
		if (link.classList.contains('main-navigation__list-item-link--level-1')) {
			// up => do nothing
			// down -> move focus to the first link item in the first child list

			if (down) {
				// find the parent level-1 li
				var parentListItem = findAncestor(link, 'main-navigation__list-item--level-1');
				// find all child level2 lists
				var childListItems = parentListItem.querySelectorAll('.main-navigation__list-item--level-2');
				if (childListItems) {
					// find the first list item
					var listItem = childListItems[0];
					if (listItem) {
						var linkItems = listItem.querySelectorAll('.main-navigation__list-item-link--level-2');
						if (linkItems) {
							// find the first link in this list
							var targetLink = linkItems[0];
							// and select it
							if (targetLink) {
								targetLink.focus();
							}
						}
					}
				}
			}
			
		} else {
			// focus is on the non-top level links
			var parentListItem = findAncestor(link, 'main-navigation__list-item');
			var nextListItem = getNextSibling(parentListItem, '.main-navigation__list-item')
			var previousListItem = getPreviousSibling(parentListItem, '.main-navigation__list-item')
			var childListItems = parentListItem.querySelectorAll('.main-navigation__list-item');

			if (down) {
				// move down...

				// if there are child links to this list item...
				if (childListItems && childListItems.length > 0) {

					// find all of the links in the first child list item
					var linkItems = childListItems[0].querySelectorAll('.main-navigation__list-item-link');

					if (linkItems) {
						// find the first link in this list
						var targetLink = linkItems[0];

						// and select it
						if (targetLink) {
							targetLink.focus();
						}
					}

				} else {

					// there are no nested child link, is there a subling after this link?

					if (nextListItem) {

						// we have a sibling, a list item after the current within the group. move focus to this

						// find the link in the next list item
						var linkItems = nextListItem.querySelectorAll('.main-navigation__list-item-link');

						if (linkItems) {

							// find the first link in this list
							var targetLink = linkItems[0];

							// and select it
							if (targetLink) {
								targetLink.focus();
							}
						}

					} else {
						// there are no child list items and no other siblings in this group, move to the next item in the parent group
						// see if there is an item after the parent list item, assuming the parent list is not the top level list

						var isUpperLevel = link.classList.contains('main-navigation__list-item-link--level-2');

						if (!isUpperLevel) {
							nextListItem = getNextSibling(parentListItem, '.main-navigation__list-item');

							if (nextListItem) {

								// we have a sibling, a list item after the current parent and within the group. move focus to this
								var linkItems = nextListItem.querySelectorAll('.main-navigation__list-item-link');

								if (linkItems) {

									// find the first link in this list
									var targetLink = linkItems[0];

									// and select it
									if (targetLink) {
										targetLink.focus();
									}
								}

							} else {
								// there is no item after the parent list item
								// go up another level, but not back up to the top-level
								parentListItem = findAncestor(parentListItem, 'main-navigation__list-item');

								if (parentListItem) {
									nextListItem = getNextSibling(parentListItem, '.main-navigation__list-item')

									if (nextListItem) {

										// we have a sibling, a list item after the current parent and within the group. move focus to this
										var linkItems = nextListItem.querySelectorAll('.main-navigation__list-item-link');

										if (linkItems) {

											// find the first link in this list
											var targetLink = linkItems[0];

											// and select it
											if (targetLink) {
												targetLink.focus();
											}
										}
									} else {

										// go back to the first list item in the parent list
										parentListItem = findAncestor(parentListItem, 'main-navigation__list-item');

										var linkItems = parentListItem.querySelectorAll('.main-navigation__list-item-link');

										if (linkItems) {

											// find the first link in this list
											var targetLink = linkItems[0];

											// and select it
											if (targetLink) {
												targetLink.focus();
											}
										}
									}
								}
							}
						} else {
							// the parent is the top level list
							// go back to the first list item at this level

							parentListItem = findAncestor(parentListItem, 'main-navigation__list-item');

							var linkItems = parentListItem.querySelectorAll('.main-navigation__list-item-link');

							if (linkItems) {

								// find the first link in this list
								var targetLink = linkItems[0];

								// and select it
								if (targetLink) {
									targetLink.focus();
								}
							}
						}
					}
				}
			} else {
				// move up...

				if (previousListItem) {

					// we have a sibling, a list item before the current and within the group
					var linkItems = previousListItem.querySelectorAll('.main-navigation__list-item-link');

					if (linkItems) {

						// find the last link in this list
						var targetLink = linkItems[(linkItems.length - 1)];

						// and select it
						if (targetLink) {
							targetLink.focus();
						}
					}

				} else {

					// no previous subling, move up a level and select the parent list item

					parentListItem = findAncestor(parentListItem, 'main-navigation__list-item');

					var linkItems = parentListItem.querySelectorAll('.main-navigation__list-item-link');

					if (linkItems) {

						// the first item in this list is the parent
						var targetLink = linkItems[0];

						// check to see if this has children, if so then the last item in this child list should get focus

						// and select it
						if (targetLink) {
							targetLink.focus();
						}
					}
				}
			}
		}
	}

	// the goal is to keep aria	and tabindex attribute values inline with the css set visibility of menu items
	if (menuItems.length) {

		for (var j = 0; j < menuItems.length; j++) {
			var link = menuItems[j];
			var index = j;


			// when focus is given to any menu item...
			link.addEventListener('focus', function () {

				toggleMainNavigation(this, true);

			})

			// when mouse-over any menu item...
			link.addEventListener('mouseover', function () {

				toggleMainNavigation(this, true);

			})

			// when focus is taken from any menu item...
			link.addEventListener('blur', function () {

				toggleMainNavigation(this, false);

			})

			// when mouse-out any menu item...
			link.addEventListener('mouseout', function () {

				toggleMainNavigation(this, false);

			})

			link.addEventListener("keyup", function (e) {
				if (e.which == 27) {
					// escape key - close the menu
					toggleMainNavigation(this, false);

					this.blur();

				} else if (e.which == 39) {
					// right arrow 
					// move to the next 'group' if there is one
					//
					moveHorizontally(this, true);

				} else if (e.which == 37) {
					// left arrow 
					// move to the previous 'group' if there is one
					//
					moveHorizontally(this, false);
				} else if (e.which == 40) {
					// down arrow - move down the list of links, or back to the top - assuming there is more than 1 link in the group
					// if there is only 1 item in the group, move to the next group
					//
					moveVertically(this, true);
				} else if (e.which == 38) {
					// up arrow - move up the list of links, or back to the bottom - assuming there is more than 1 link in the group
					// if there is only 1 item in the group, move to the previous group
					//
					moveVertically(this, false);
				}
			})
		}

	}

	var sticky = navbar.offsetTop;

	// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
	function stickyMainNav() {
		if (window.pageYOffset >= sticky) {
			// navbar.classList.add("sticky")
			document.documentElement.classList.add("sticky")
			headerContainer.classList.add("sticky");
		} else {
			// navbar.classList.remove("sticky");
			document.documentElement.classList.remove("sticky")
			headerContainer.classList.remove("sticky");
		}
	}

	// attach scroll event
	window.onscroll = function () { stickyMainNav() };
}

if (document.readyState !== 'loading') {
	window.SetUpMainNav();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.SetUpMainNav();
	});
}